import { Box } from '@mui/material';

import { FlagIcon, RadioBoxButton } from '@/components';
import {
  onboardingActions,
  selectNonDesignatedCountryOptions,
  selectOnboardingStepInputs,
  STEP_IDS,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { Link } from '../../Link';
import { styles } from '../styles';
import { Footer } from './Footer';
import { Header } from './Header';
import { ModalSubtitle } from './ModalSubtitle';
import { ModalTitle } from './ModalTitle';

export const NonDesignatedRegion = () => {
  const dispatch = useAppDispatch();

  const stepInputs = useAppSelector(selectOnboardingStepInputs);
  const nonDesignatedCountryOptions = useAppSelector(
    selectNonDesignatedCountryOptions,
  );

  const { value: input } = stepInputs[STEP_IDS.nonDesignatedRegion];

  return (
    <Box sx={styles.formContainer}>
      <Header Title={<Title />} Subtitle={<Subtitle />} />
      <Box sx={styles.formPrimarySection}>
        {Object.entries(nonDesignatedCountryOptions).map(
          ([countryCode, country]) => (
            <Box key={countryCode} sx={styles.checkboxContainer}>
              <RadioBoxButton
                label={country.name}
                checked={input === countryCode}
                onChange={() =>
                  dispatch(
                    onboardingActions.updateStepInputs({
                      step: STEP_IDS.nonDesignatedRegion,
                      input: countryCode,
                    }),
                  )
                }>
                <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                  <FlagIcon region={countryCode} />
                </Box>
              </RadioBoxButton>
            </Box>
          ),
        )}
      </Box>
      <Footer />
    </Box>
  );
};

const Title = () => (
  <ModalTitle>Please select your country or region.</ModalTitle>
);

const Subtitle = () => (
  <ModalSubtitle>
    Don&apos;t see your country or region listed?{' '}
    <Link inline onClick={() => window.Intercom?.('show')}>
      Let us know
    </Link>
  </ModalSubtitle>
);
